export default "__VITE_ASSET__6ce3782f__"